export const telezhki = {
    metall_type: [
        {
            actual: true,
            name: "telezhka__tm",
            pageName: "tm",
            tempName: "tm",
            glbPath: "telezhki/",
            glbName: "telezhka__tm.glb",
            nextMenu: "tm",
            menuTitle: "Тележка ТМ",
            title: "Тележка ТМ",
            imgName: "telezhka__tm.webp",
            allArrTable: "allStoyka",
            defaultWidth: 500,
            defaultDepth: 900,
        },
        {
            actual: true,
            name: "telezhka__ti",
            pageName: "ti",
            tempName: "ti",
            glbPath: "telezhki/",
            glbName: "telezhka__ti.glb",
            nextMenu: "ti",
            menuTitle: "Тележка ТИ",
            title: "Тележка ТИ",
            imgName: "telezhka__ti.webp",
            allArrTable: "allStoyka",
            defaultWidth: 600,
            defaultDepth: 500,
        },
        {
            actual: true,
            name: "telezhka__tmu",
            pageName: "tmu",
            tempName: "tmu",
            glbPath: "telezhki/",
            glbName: "telezhka__tmu.glb",
            nextMenu: "tmu",
            menuTitle: "Тележка ТМУ",
            title: "Тележка ТМУ",
            imgName: "telezhka__tmu.webp",
            allArrTable: "allStoyka",
            defaultWidth: 600,
            defaultDepth: 500,
        },
    ],
    construct_type: [
        {
            actual: true,
            name: "telezhka__al_kp",
            pageName: "al_kp",
            tempName: "al_kp",
            glbPath: "telezhki/",
            glbName: "telezhka__al_kp.glb",
            nextMenu: "al_kp",
            menuTitle: "Тележка АЛ-КП",
            title: "Тележка АЛ-КП",
            imgName: "al_kp.webp",
            allArrTable: "allStoyka",
            defaultWidth: 600,
            defaultDepth: 600,
        },
    ],
};
